import { create } from 'zustand'
import { BetDetailResponse, DropDetail, GameDetail } from '../models/BetDetailResponse'
import { FREE_GAME_SYMBOL_MAP, FreeGameType } from '../../game/model/GameResult'

export enum GameType {
  MainGame = 'MainGame',
  GodziGame = 'GodziGame',
}

export enum SpinType {
  MainSpin = 'MainSpin',
  BonusSpin = 'BonusSpin',
}

export interface IBetDetailStore {
  isFromOpBetDetail: boolean
  betDetailData: BetDetailResponse | null
  isOpen: boolean
  selectShowGameType: GameType
  selectSpinType: SpinType
  currentMgIndex: number
  currentFgIndex: number
  setCurrentMgIndex: (index: number) => void
  setCurrentFgIndex: (index: number) => void
  setCurrentIndex: (index: number) => void
  getCurrentIndex: () => number
  getCurrentDropDetail: () => DropDetail
  getCurrentGameDetail: () => GameDetail
  getTriggerBonusGameDetail: () => { type: number, count: number, payout: number }[]
  getHasPrev: () => boolean
  getHasNext: () => boolean
  getMaxIndex: () => number
}

export const useBetDetailStore = create<IBetDetailStore>((set, get) => ({
  isFromOpBetDetail: false,
  betDetailData: null,
  isOpen: false,
  selectShowGameType: GameType.MainGame,
  selectSpinType: SpinType.MainSpin,
  currentMgIndex: 0,
  currentFgIndex: 0,
  setCurrentMgIndex: index => set({ currentMgIndex: index }),
  setCurrentFgIndex: index => set({ currentFgIndex: index }),
  setCurrentIndex: (index: number) => {
    if (get().selectSpinType === SpinType.MainSpin) {
      set({ currentMgIndex: index })
    }
    else {
      set({ currentFgIndex: index })
    }
  },
  getCurrentIndex: () => {
    const store = get()
    return store.selectSpinType === SpinType.MainSpin
      ? store.currentMgIndex
      : store.currentFgIndex
  },
  getCurrentDropDetail: () => {
    const store = get()
    const isMainSpin = store.selectSpinType === SpinType.MainSpin
    const gameDetail = store.getCurrentGameDetail()
    return isMainSpin
      ? gameDetail.mgDropList[get().getCurrentIndex()]
      : gameDetail.fgDropList[get().getCurrentIndex()]
  },
  getCurrentGameDetail: () => {
    const store = get()
    const detail = store.betDetailData as BetDetailResponse
    const gameDetail = store.selectShowGameType === GameType.MainGame ? detail.gameDetail : detail.godziDropResult.gameResultList[0]
    return gameDetail
  },
  getTriggerBonusGameDetail: () => {
    const store = get()
    const isMainSpin = store.selectSpinType === SpinType.MainSpin
    const gameDetail = store.getCurrentGameDetail()

    const dropData = isMainSpin
      ? gameDetail.mgDropList[get().getCurrentIndex()]
      : gameDetail.fgDropList[get().getCurrentIndex()]
    if (!dropData) return []

    const freeGameType = dropData.freeGameType as FreeGameType
    const targetTypes = FREE_GAME_SYMBOL_MAP[freeGameType]
    const result: { type: number, count: number, payout: 0 }[] = []

    targetTypes.forEach((target) => {
      let count = 0

      dropData.reelTable.forEach((column) => {
        column.forEach((symbol) => {
          if (Number(symbol.type) === target) {
            count++
          }
        })
      })

      if (count > 0) {
        result.push({ type: target, count, payout: 0 })
      }
    })

    return result
  },
  getHasPrev: () => get().getCurrentIndex() > 0,
  getHasNext: () => get().getCurrentIndex() < get().getMaxIndex(),
  getMaxIndex: () => {
    // wip max index
    const store = get()
    const gameDetail = store.getCurrentGameDetail()
    if (!gameDetail) return 0

    const isMainSpin = store.selectSpinType === SpinType.MainSpin
    const detailList = isMainSpin ? gameDetail.mgDropList : gameDetail.fgDropList

    return detailList.length > 0 ? detailList.length - 1 : 0
  },
}))
